import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { exchangeGoogleSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate('/auth', { replace: true }); return; }

    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        // Clear the hash so it doesn't loop
        window.history.replaceState(null, '', window.location.pathname);
        await exchangeGoogleSession(sessionId);
        navigate('/home', { replace: true });
      } catch (err) {
        toast.error('Google sign-in failed');
        navigate('/auth', { replace: true });
      }
    })();
  }, [location.hash, exchangeGoogleSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-aura-bg">
      <div className="text-center space-y-3">
        <div className="text-5xl animate-aura-pulse">⚡</div>
        <div className="text-aura-textDim font-display tracking-widest text-sm">CONNECTING…</div>
      </div>
    </div>
  );
}
